/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
export const SvgArrowTopRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={14}
    height={14}
    viewBox='0 0 14 14'
    xmlns='http://www.w3.org/2000/svg'
    role='img'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.72531 4.13786C3.72848 3.56349 4.19667 3.10044 4.77104 3.10362L9.83424 3.13158C10.4041 3.13473 10.8653 3.59594 10.8685 4.16582L10.8964 9.22902C10.8996 9.80339 10.4366 10.2716 9.86221 10.2748C9.28784 10.2779 8.81965 9.81488 8.81648 9.24051L8.80227 6.66857L4.90703 10.5638C4.50089 10.97 3.84239 10.97 3.43625 10.5638C3.0301 10.1577 3.0301 9.49918 3.43625 9.09303L7.33149 5.19779L4.75955 5.18358C4.18518 5.18041 3.72214 4.71222 3.72531 4.13786Z'
    />
  </svg>
)
export default SvgArrowTopRight
